<template>
  <div class="w-full bg-white height-100">
    <el-dialog
      width="30%"
      title=""
      :visible.sync="isshowAttribute"
      :direction="direction"
      :before-close="handleClose"
    >
      <template slot="title"></template>
      <div class="p-4 items-center">
        <div class="flex justify-center w-full">
          <img
            src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png"
            class="new-height"
          />
        </div>

        <p class="fsize14 text-dark text-center font-medium my-4">
          Billing is available only for other BRAINED's Subscription Plans.
          Please upgrade to other plan to access this feature
        </p>

        <div class="flex w-full mt-4 gap-2">
          <vs-button
            color="primary"
            class="bg-primary w-full"
            @click="
              () => {
                centerDialogVisible = false;
                this.$router.push({ name: 'plans-vue' });
              }
            "
            >Upgrade</vs-button
          >

          <vs-button
            color="secondary"
            class="bg-secondary w-full"
            @click="isshowAttribute = false"
            >Cancel</vs-button
          >
        </div>
      </div>
    </el-dialog>
    <div class="seth-set bg-primary">
      <div class="absolute top-0 py-10 w-full px-6 flex">
        <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
          Billing
        </h2>
      </div>
    </div>
    <div class="flex menucontrol-scroll fixed-top justify-center items-center">
      <div
        v-if="selectedProject.billingStatus === true"
        class="w-full bg-white p-8 h-bill flex justify-center items-center"
      >
        <div class="text-center">
          <img class="" src="@/assets/images/new/billing.svg" alt="bill" />
          <h2 class="text-3xl font-semibold text-black">
            All your billing in one place
          </h2>
          <p class="text-lg font-semibold text-gray mt-2">
            Manage all your billing in one go. If you're logging in for the
            first time,
            <br />
            Please click the one-time registration link forwarded on
            <span class="text-primary ml-1">{{
              selectedProject.billingEmail
            }}</span>
          </p>
          <vs-button
            variant="primary"
            class="font-semibold rounded-full fsize14 py-4 mt-3 px-12 sm-fsize14"
            @click="openBilling"
          >
            One Billing Zone
          </vs-button>
        </div>
      </div>

      <div v-else-if="selectedProject.billingStatusRequest === true">
        <div class="w-full bg-white flex justify-center items-center">
          <div class="">
            <div>
              <div class="flex justify-center">
                <img
                  src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png"
                  class="w-100px"
                />
              </div>
              <div class="text-center mt-4">
                <h4 class="font-semibold text-4d4d4d text-3xl">
                  All done! Time to review
                </h4>
                <p class="fsize14 col-4f mt-2">
                  Please come after 24-48 hours.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div>
          <div class="flex justify-center">
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/template/pay.png"
              class=""
            />
          </div>
          <div class="text-center mt-4">
            <h4 class="font-semibold text-4d4d4d text-3xl">
              Your Billing Portal is not setup
            </h4>
            <p class="fsize14 text-8f8f8f mt-2">
              Click the below button to activate it.
            </p>
          </div>
          <div class="flex gap-4 mt-6 justify-center items-center">
            <vs-button
              variant="primary"
              @click="updateBill"
              class="font-semibold rounded-full fsize14 py-4 px-12 sm-fsize14"
            >
              Activate
            </vs-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import VueEllipseProgress from "vue-ellipse-progress";
import { mapState } from "vuex";
export default {
  data() {
    return {
      isshowAttribute: false,
    };
  },
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },

    async billingStatus() {
      const payload = {
        projectId: this.selectedProject._id,
      };
      await this.$store.dispatch("user/getProject", payload);
    },

    async updateBill() {
      if (this.selectedPlan[0].subscription.name !== "Free") {
        const payload = {
          projectId: this.selectedProject._id,
          billingStatusRequest: true,
          projectName: this.selectedProject.projectName,
        };
        await this.$store.dispatch("user/updateBill", payload);
        this.billingStatus();
      } else {
        this.isshowAttribute = true;
      }
    },

    openBilling() {
      window.open(`${process.env.VUE_APP_BILLING_URL}`, "_blank");
    },
  },
  computed: {
    ...mapState("user", ["selectedProject"]),
    ...mapState("admin", ["selectedPlan"]),
  },
  mounted() {
    this.billingStatus();
  },
};
</script>
<style>
.h80per {
  height: 80%;
}
</style>
